import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const BeforeAfterComparison = () => {
  const [sliderPosition, setSliderPosition] = useState(50);

  const comparisonData = {
    copper: {
      speed: "10-100 Mbps",
      reliability: "85% uptime",
      latency: "15-50ms",
      maintenance: "$2,400/year",
      futureProof: "Limited scalability"
    },
    fiber: {
      speed: "1-10 Gbps+",
      reliability: "99.9% uptime", 
      latency: "1-5ms",
      maintenance: "$600/year",
      futureProof: "Future-ready"
    }
  };

  const handleSliderChange = (e) => {
    setSliderPosition(e?.target?.value);
  };

  return (
    <div className="bg-white rounded-xl shadow-brand-strong p-8 mb-12">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-text-primary mb-4">
          See the Transformation
        </h2>
        <p className="text-text-secondary text-lg">
          Move the slider to compare copper vs fiber performance
        </p>
      </div>
      <div className="relative bg-gradient-to-r from-red-50 to-green-50 rounded-lg p-8 mb-8">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Copper Side */}
          <div className={`transition-opacity duration-300 ${sliderPosition > 50 ? 'opacity-40' : 'opacity-100'}`}>
            <div className="flex items-center mb-4">
              <div className="w-4 h-4 bg-red-500 rounded-full mr-3"></div>
              <h3 className="text-xl font-bold text-red-700">Legacy Copper</h3>
            </div>
            <div className="space-y-3">
              {Object.entries(comparisonData?.copper)?.map(([key, value]) => (
                <div key={key} className="flex justify-between items-center p-3 bg-white/70 rounded-lg">
                  <span className="font-medium text-gray-700 capitalize">
                    {key?.replace(/([A-Z])/g, ' $1')?.trim()}:
                  </span>
                  <span className="text-red-600 font-semibold">{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Fiber Side */}
          <div className={`transition-opacity duration-300 ${sliderPosition < 50 ? 'opacity-40' : 'opacity-100'}`}>
            <div className="flex items-center mb-4">
              <div className="w-4 h-4 bg-green-500 rounded-full mr-3"></div>
              <h3 className="text-xl font-bold text-green-700">Fiber Optic</h3>
            </div>
            <div className="space-y-3">
              {Object.entries(comparisonData?.fiber)?.map(([key, value]) => (
                <div key={key} className="flex justify-between items-center p-3 bg-white/70 rounded-lg">
                  <span className="font-medium text-gray-700 capitalize">
                    {key?.replace(/([A-Z])/g, ' $1')?.trim()}:
                  </span>
                  <span className="text-green-600 font-semibold">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Slider */}
        <div className="absolute inset-x-8 top-1/2 transform -translate-y-1/2">
          <div className="relative">
            <input
              type="range"
              min="0"
              max="100"
              value={sliderPosition}
              onChange={handleSliderChange}
              className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer slider"
            />
            <div 
              className="absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2 w-8 h-8 bg-primary rounded-full shadow-lg flex items-center justify-center cursor-pointer"
              style={{ left: `${sliderPosition}%` }}
            >
              <Icon name="ArrowLeftRight" size={16} color="white" />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center">
        <p className="text-text-secondary mb-4">
          Experience up to <span className="font-bold text-accent">100x faster speeds</span> and 
          <span className="font-bold text-accent"> 75% lower maintenance costs</span>
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <div className="flex items-center text-sm text-text-secondary">
            <Icon name="Zap" size={16} className="mr-2 text-accent" />
            Lightning Fast
          </div>
          <div className="flex items-center text-sm text-text-secondary">
            <Icon name="Shield" size={16} className="mr-2 text-accent" />
            Ultra Reliable
          </div>
          <div className="flex items-center text-sm text-text-secondary">
            <Icon name="TrendingUp" size={16} className="mr-2 text-accent" />
            Future Ready
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterComparison;